import { render, staticRenderFns } from "./SectorInfo.vue?vue&type=template&id=7f390ffc&scoped=true&lang=pug&"
import script from "./SectorInfo.vue?vue&type=script&lang=js&"
export * from "./SectorInfo.vue?vue&type=script&lang=js&"
import style0 from "./SectorInfo.vue?vue&type=style&index=0&id=7f390ffc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f390ffc",
  null
  
)

export default component.exports